import { request_general_lang } from './../../language/request_general';
import { Component,OnInit,ChangeDetectorRef } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import jsreport from 'jsreport-browser-client-dist/jsreport';
import * as moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { thLocale } from 'ngx-bootstrap/locale';
defineLocale('engb', enGbLocale);
defineLocale('th', thLocale);
declare var url;
declare var report_url;
declare var report_service_url;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

class request {
  request_general_id: string;
  request_time: string;
  customer_fullname: string;
  request_desc: string;
  request_to: string;
}

@Component({
  selector: 'app-request-general',
  templateUrl: './request-general.component.html',
  styleUrls: ['./request-general.component.scss']
})
export class RequestGeneralComponent implements OnInit {
  isEditMode = true;
  isEditModee:boolean;
  lang=localStorage.getItem('lang')=="EN"?"EN":"TH";
  language:any;
  isLoading=true;
  showPage=false;
  showAdd=false;
  showUpdate=false;
  customers:any;
  customer=[];
  filteredCustomer=[];
  submitted=false;
  customer_places=[];
  customer_place:any;
  //drop down 
  dropdownSettings:IDropdownSettings = {
    singleSelection: true,
    idField: 'customer_id',
    textField: 'customer_fullname',
    selectAllText: 'เลือกทั้งหมด',
    unSelectAllText: 'ไม่เลือกทั้งหมด',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  dropdownSettingsPlace:IDropdownSettings = {
    singleSelection: true,
    idField: 'place_id',
    textField: 'place_address',
    selectAllText: 'เลือกทั้งหมด',
    unSelectAllText: 'ไม่เลือกทั้งหมด',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  value = 
  {
    request_general_id:'',
    customer_id:'',
    place_id:'',
    request_to:'',
    request_desc:'',
    opinion:'',
    user_id:'',
    command_desc:'',
    request_at:'',
    request_time:'',
    status:'',
    flag:''
  }

  municipality_id='';
  token='';
  database='';
  dtOptions: DataTables.Settings = {};
  requests: request[];

  constructor(
    private http: HttpClient,
    private service:MyserviceService,
    private chRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private localeService : BsLocaleService,
    private router: Router,
    private modalService: BsModalService)
    {
      this.language=request_general_lang[this.lang];
    }

  ngOnInit() {

    if(sessionStorage.getItem('municipality')!=undefined){
      this.database=JSON.parse(sessionStorage.getItem('municipality')).municipality_id+'_fee'
    }

    if(sessionStorage.getItem('token') !=undefined){
      this.token=sessionStorage.getItem('token');
    }

    this.isLoading=false;
    this.showPage=true;
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        console.log('request-general/get-request-general_to_datatable')
        that.http
          .post<DataTablesResponse>(
            url + 'request-general/get-request-general_to_datatable',
            dataTablesParameters, {
              headers: new HttpHeaders({
              'Content-Type': 'application/json; charset=utf-8',
              'x-access-token': this.token,
              'database': this.database
              })}
          ).subscribe(resp => {
              //debugger
              that.requests=resp.data.map((item)=>{
              var xy = 0;
              xy = parseInt(moment(item.request_time).format('YYYY'));
      
              if (xy < 2500) 
              {
                xy = xy + 543;
              }
      
              item.request_time=moment(item.request_time).format('DD/MM/') + xy + ' ' + moment(item.request_time).format('HH:mm:ss');
              return item;
            });
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
        columns: [{ data: 'rg.request_general_id' }, { data: 'to_char(rg.request_time,\'DD/MM/YYYY HH:mm:ss\')' }, { data: `concat(pf.short_name,case when cs.customer_name = '' or cs.customer_name is null then rg.customer_id else cs.customer_name end,' ',cs.customer_surname)` } , { data: 'rg.request_desc' }  , { data: 'rg.request_to' }
        , { data: `(CASE WHEN rg.status = '01' THEN 'รอดำเนินการ' WHEN rg.status = '02' THEN 'อนุมัติ' WHEN rg.status = '03' THEN 'ไม่อนุมัติ' END)` } , { data: '' }  ]
    };

    this.route.queryParams.subscribe(params => {
      this.lang= params['lang'];
      if(this.lang!='EN'&&this.lang!='TH'){
        this.lang=localStorage.getItem('lang')=='EN'?'EN':'TH';
        this.language=request_general_lang[this.lang];
      }else{
        this.language=request_general_lang[this.lang];
        localStorage.setItem('lang',this.lang);
      }
   });
  }

  showInformation(row)
  {
    const municipality_id=this.service.getDatabase().substring(0,5);
    jsreport.serverUrl = report_service_url;
    
    var dateString = moment(row.request_time).format('MM-DD-YYYY');
    var x = moment(dateString, 'MM-DD-YYYY').locale('th-TH');
    var xy = 0;
    xy = parseInt(x.format('YYYY'));

    if (xy < 2500) 
    {
      xy = xy + 543;
    }

    this.service.postData({customer_id:row.customer_id},"customer-place/get_place").then((result:any)=>
    {
      let place=JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""))
      
      if (place.length > 0) 
      {
        let house_number = (place[0].place_number == '' || place[0].place_number == ' ') ? '-' : place[0].place_number;
        let house_moo = (place[0].place_group == '' || place[0].place_group == ' ') ? '-' : place[0].place_group;
        let house_road = (place[0].place_road == '' || place[0].place_road == ' ') ? '-' : place[0].place_road;
        let house_tambon = (place[0].tambon_th == '' || place[0].tambon_th == ' ') ? '-' : place[0].tambon_th;
        let house_amphur = (place[0].amphur_th == '' || place[0].amphur_th == ' ') ? '-' : place[0].amphur_th;
        let house_province = (place[0].province_th == '' || place[0].province_th == ' ') ? '-' : place[0].province_th;

        if (this.lang!='TH')
        {
          house_tambon = (place[0].tambon_en == '' || place[0].tambon_en == ' ') ? '-' : place[0].tambon_en;
          house_amphur = (place[0].amphur_en == '' || place[0].amphur_en == ' ') ? '-' : place[0].amphur_en;
          house_province = (place[0].province_en == '' || place[0].province_en == ' ') ? '-' : place[0].province_en;
        }

        let house_mobile = (place[0].place_mobile == '' || place[0].place_mobile == ' ') ? '-' : place[0].place_mobile;

        var request = {
          template: { name : 'request-general'},
          data:
          {
              "title":"คำร้องทั่วไป",
              "request_at":(row.request_at == '' || row.request_at == ' ') ? '-' : row.request_at,
              "request_date":x.format('DD'),
              "request_month":x.format('MMMM'),
              "request_year":xy,
              "request_customer":(row.customer_fullname == '' || row.customer_fullname == ' ') ? '-' : row.customer_fullname,
              "request_age":"-",
              "request_race":(row.customer_race == '' || row.customer_race == ' ') ? '-' : row.customer_race,
              "request_nationality":(row.customer_nationality == '' || row.customer_nationality == ' ') ? '-' : row.customer_nationality,
              "request_house_number":house_number,
              "request_house_moo":house_moo,
              "request_house_road":house_road,
              "request_house_tambon":house_tambon,
              "request_house_amphur":house_amphur,
              "request_house_province":house_province,
              "request_house_mobile":house_mobile,
              "request_to":(row.request_to == '' || row.request_to == ' ') ? '-' : row.request_to,
              "request_desc1":(row.request_desc == '' || row.request_desc == ' ') ? '-' : row.request_desc,
              "request_desc2":"-",
              "request_desc3":"-",
              "request_desc4":"-",
              "request_desc5":"-",
              "opinion1":(row.opinion == '' || row.opinion == ' ') ? '-' : row.opinion,
              "opinion2":"-",
              "opinion3":"-",
              "opinion4":"-",
              "command1":(row.command_desc == '' || row.command_desc == ' ') ? '-' : row.command_desc,
              "request_general_id":(row.request_general_id == '' || row.request_general_id == ' ') ? '-' : row.request_general_id
          }
        };
    
        localStorage.setItem('dataOfPrint',JSON.stringify(request));
        window.open(report_url+"print-request-general?municipality_id="+municipality_id,"_blank");  
      }
      else 
      {
        var request2 = {
          template: { name : 'request-general'},
          data:
          {
            "title":"คำร้องทั่วไป",
            "request_at":(row.request_at == '' || row.request_at == ' ') ? '-' : row.request_at,
            "request_date":x.format('DD'),
            "request_month":x.format('MMMM'),
            "request_year":xy,
            "request_customer":(row.customer_fullname == '' || row.customer_fullname == ' ') ? '-' : row.customer_fullname,
            "request_age":"-",
            "request_race":(row.customer_race == '' || row.customer_race == ' ') ? '-' : row.customer_race,
            "request_nationality":(row.customer_nationality == '' || row.customer_nationality == ' ') ? '-' : row.customer_nationality,
            "request_house_number":'-',
            "request_house_moo":'-',
            "request_house_road":'-',
            "request_house_tambon":'-',
            "request_house_amphur":'-',
            "request_house_province":'-',
            "request_house_mobile":'-',
            "request_to":(row.request_to == '' || row.request_to == ' ') ? '-' : row.request_to,
            "request_desc1":(row.request_desc == '' || row.request_desc == ' ') ? '-' : row.request_desc,
            "request_desc2":"-",
            "request_desc3":"-",
            "request_desc4":"-",
            "request_desc5":"-",
            "opinion1":(row.opinion == '' || row.opinion == ' ') ? '-' : row.opinion,
            "opinion2":"-",
            "opinion3":"-",
            "opinion4":"-",
            "command1":(row.command_desc == '' || row.command_desc == ' ') ? '-' : row.command_desc,
            "request_general_id":(row.request_general_id == '' || row.request_general_id == ' ') ? '-' : row.request_general_id
          }
        };
    
        localStorage.setItem('dataOfPrint',JSON.stringify(request2));
        window.open(report_url+"print-request-general?municipality_id="+municipality_id,"_blank");
      }
      
    });
      
  }

  add()
  {
      this.isLoading=true;
      this.service.postData({},"request-general/getId").then((result:any)=>{
        this.value.request_general_id=result.max_id;
        this.value.request_at='เทศบาลเมืองพะเยา';
        this.value.request_at='เทศบาลเมืองพะเยา';
        this.service.postData({},"customer/get").then((result:any)=>
        {
          if(result.hasError){
            Swal.fire(result.message,'','error');
          }else{
            this.isLoading=false;
            this.showPage=false;
            this.showAdd=true;
            this.customers=JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""))
            this.filteredCustomer = [];
            if (this.customers.length > 20) 
            {
              for (var i=0;i<=20-1;i++) 
              {
                this.filteredCustomer.push(this.customers[i]);
              }
            }
            else 
            {
              for (var i=0;i<=this.customers.length-1;i++) 
              {
                this.filteredCustomer.push(this.customers[i]);
              }
            }

            this.customer=[];
            this.customer_place=[];
          }
        })
      },err=>{
        window.location.href=this.service.start_host
      });
  }

  back()
  {
    this.isLoading=false;
    this.showPage=true;
    this.showAdd=false;
    this.showUpdate=false;
    this.filteredCustomer=[];
    this.customers=[];
    this.customer_places=[];
    this.value = 
    {
      request_general_id:'',
      customer_id:'',
      place_id:'',
      request_to:'',
      request_desc:'',
      opinion:'',
      user_id:'',
      command_desc:'',
      request_at:'',
      request_time:'',
      status:'',
      flag:''
    }

  }

  save()
  {
    this.submitted=true;
    this.value.user_id=JSON.parse(sessionStorage.getItem('user')).username;

    if (this.showAdd == true) 
    {
      if (this.value.customer_id != '' && this.value.place_id != '' && this.value.request_general_id != '' && this.value.request_to != '' && this.value.request_desc != ''  && this.value.opinion != ''  && this.value.user_id != '')
      {
        this.value.request_time=moment().format('YYYY-MM-DD HH:mm:ss');
        this.value.status='01';
        this.value.flag='1';
        this.service.postData({request_general:this.value,ckflag:'01'},"request-general/create").then((result:any)=>
        {
          if (!result.code) 
          {
            Swal.fire({
              title:  this.language.saved,
              text: '',
              type: 'success',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
            })
    
            this.back()
            location.reload();

          }
          else 
          {
            Swal.fire({
              title:  this.language.errored,
              text: '',
              type: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
            })
          }
         
        })
      }
    }
    else 
    {
      if (this.value.command_desc != '')
      {
        this.value.request_time=moment().format('YYYY-MM-DD HH:mm:ss');
        this.value.status='03';
        this.value.flag='1';
        this.service.postData({request_general:this.value},"request-general/create").then((result:any)=>
        {
          if (!result.code) 
          {
            Swal.fire({
              title:  this.language.saved,
              text: '',
              type: 'success',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
            })
    
            this.back()
            location.reload();

          }
          else 
          {
            Swal.fire({
              title:  this.language.errored,
              text: '',
              type: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
            })
          }
         
        })
      }
    }

  }

  private _filterCustomer(subject_text: string): any[] {
    const filterValue = subject_text.toLowerCase();

    return this.customers.filter(option => (option.customer_name+' '+option.customer_surname).toLowerCase().indexOf(filterValue) === 0);
  }

  isFloat=value=> !/^\s*$/.test(value) && !isNaN(value)

  onItemSelect(item: any) {
    console.log(this.customer);
    this.value.customer_id = this.customer[0].customer_id;
    this.getCustomer_place();
  }

  onFilterCustomer(item: any)
  {
    console.log(item);
    if (item.length >= 2) 
    {
      this.filteredCustomer = [];
      var filteredCustomer = this._filterCustomer(item)

      if (filteredCustomer.length > 0) 
      {
        if (filteredCustomer.length > 20) 
        {
          for (var i=0;i<=20-1;i++) 
          {
            this.filteredCustomer.push(filteredCustomer[i]);
          }
        }
        else 
        {
          for (var i=0;i<=filteredCustomer.length-1;i++) 
          {
            this.filteredCustomer.push(filteredCustomer[i]);
          }
        }
        
      }
      else 
      {
        if (this.customers.length > 20) 
        {
          for (var i=0;i<=20-1;i++) 
          {
            this.filteredCustomer.push(this.customers[i]);
          }
        }
        else 
        {
          for (var i=0;i<=this.customers.length-1;i++) 
          {
            this.filteredCustomer.push(this.customers[i]);
          }
        }
      }
    }
  }

  getCustomer_place()
  {
    
    this.service.postData({customer_id:this.value.customer_id},"customer-place/get").then((result:any)=>{
      this.customer_place=[];
      this.value.place_id='';
      this.customer_places=result.data;
    },err=>{
      window.location.href=this.service.start_host
    })
  }

  onItemSelectPlace(item: any) {
    console.log(this.customer_place);
    this.value.place_id = this.customer_place[0].place_id;
  }

  update(row)
  {
    this.showAdd=false;
    this.showPage=false;
    this.showUpdate=true;
    console.log(row);
    if (row.status === '02' || row.status === '03') {
      this.isEditModee = true;
    } else {
      this.isEditModee = false;
    }
    
    this.customer = [
      {
        customer_id:row.customer_id,
        customer_fullname:row.customer_fullname
      }]
    this.customer_place = [
      {
        place_id:row.place_id,
        place_address:row.place_address
      }]

    this.value = 
    {
      request_general_id:row.request_general_id,
      customer_id:row.customer_id,
      place_id:row.place_id,
      request_to:row.request_to,
      request_desc:row.request_desc,
      opinion:row.opinion,
      user_id:row.user_id,
      command_desc:row.command_desc,
      request_at:row.request_at,
      request_time:row.request_time,
      status:'',
      flag:''
    }
  }


  // approve() {

  //   if (row != undefined || this.requests.length == 1) {
  //     if (row == undefined) {
  //       row = this.requests[0];
  //     }

  //     if (row.flag == '1' || row.flag == 'รอดำเนินการ') {
  //       Swal.fire({
  //         title: this.language.approve_title,
  //         text: this.language.approve_detail,
  //         type: 'warning',
  //         showCancelButton: true,
  //         confirmButtonColor: '#3085d6',
  //         cancelButtonColor: '#d33',
  //         confirmButtonText: this.language.approve,
  //         cancelButtonText: this.language.approve_cancel
  //       }).then((result) => {
  //         if (result.value) {
  //           this.service.postData({request_general:this.value},"request-general/create").then((result:any)=>{
  //           // this.service.postData({ request_id: request.request_id, flag: '2' }, "customer-request/update").then((result: any) => {
  //             if (!result.code) {
  //               Swal.fire({
  //                 title: this.language.approve,
  //                 text: '',
  //                 type: 'success',
  //                 showCancelButton: false,
  //                 showConfirmButton: false,
  //                 timer: 2000
  //               }).then((result) => {
  //                 window.location.reload();
  //               })
  //             }
  //           }, err => {
  //             window.location.href = this.service.start_host
  //           })
  //         }
  //       })
  //     }
  //     else {
  //       Swal.fire({
  //         title: this.language.inform_title,
  //         text: this.language.inform_detail,
  //         type: 'warning',
  //         showCancelButton: false,
  //         confirmButtonColor: '#3085d6',
  //         confirmButtonText: this.language.inform_confirm
  //       }).then((result) => {
  //         if (result.value) { }
  //       })
  //     }
  //   }

  // }
  approve()
  {
    this.submitted=true;
    this.value.user_id=JSON.parse(sessionStorage.getItem('user')).username;

   
      if (this.value.customer_id != '' && this.value.place_id != '' && this.value.request_general_id != '' && this.value.request_to != '' && this.value.request_desc != ''  && this.value.opinion != ''  && this.value.user_id != '')
      {
        this.value.request_time=moment().format('YYYY-MM-DD HH:mm:ss');
        this.value.status='03';
        this.value.flag='1';
        this.service.postData({request_general:this.value,ckflag:'03'},"request-general/create").then((result:any)=>
        {
          if (!result.code) 
          {
            Swal.fire({
              title:  this.language.saved,
              text: '',
              type: 'success',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
            })
    
            this.back()
            location.reload();

          }
          else 
          {
            Swal.fire({
              title:  this.language.errored,
              text: '',
              type: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
            })
          }
         
        })
      }
    
    else 
    {
      if (this.value.command_desc != '')
      {
        this.value.request_time=moment().format('YYYY-MM-DD HH:mm:ss');
        this.value.status='03';
        this.value.flag='1';
        this.service.postData({request_general:this.value,flag:'01'},"request-general/create").then((result:any)=>
        {
          if (!result.code) 
          {
            Swal.fire({
              title:  this.language.saved,
              text: '',
              type: 'success',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
            })
    
            this.back()
            location.reload();

          }
          else 
          {
            Swal.fire({
              title:  this.language.errored,
              text: '',
              type: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
            })
          }
         
        })
      }
    }

  }

  notapprove()
  {
    this.submitted=true;
    this.value.user_id=JSON.parse(sessionStorage.getItem('user')).username;

    if (this.showAdd == true) 
    {
      if (this.value.customer_id != '' && this.value.place_id != '' && this.value.request_general_id != '' && this.value.request_to != '' && this.value.request_desc != ''  && this.value.opinion != ''  && this.value.user_id != '')
      {
        this.value.request_time=moment().format('YYYY-MM-DD HH:mm:ss');
        this.value.status='02';
        this.value.flag='1';
        this.service.postData({request_general:this.value,ckflag:'03'},"request-general/create").then((result:any)=>
        {
          if (!result.code) 
          {
            Swal.fire({
              title:  this.language.saved,
              text: '',
              type: 'success',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
            })
    
            this.back()
            location.reload();

          }
          else 
          {
            Swal.fire({
              title:  this.language.errored,
              text: '',
              type: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
            })
          }
         
        })
      }
    }
    else 
    {
      if (this.value.command_desc != '')
      {
        this.value.request_time=moment().format('YYYY-MM-DD HH:mm:ss');
        this.value.status='02';
        this.value.flag='1';
        this.service.postData({request_general:this.value},"request-general/create").then((result:any)=>
        {
          if (!result.code) 
          {
            Swal.fire({
              title:  this.language.saved,
              text: '',
              type: 'success',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
            })
    
            this.back()
            location.reload();

          }
          else 
          {
            Swal.fire({
              title:  this.language.errored,
              text: '',
              type: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer:2000
            })
          }
         
        })
      }
    }

  }
}
